import { isVisibleGraphEdge } from "./filterGraphEdges";
import type { LogicalEdgeRef, PlanarGraph, SegmentEntry, SegmentSpec } from "./types";

export function segmentById(
  state: PlanarGraph,
  id: string,
): SegmentEntry | undefined {
  return state.segments.find((s) => s.spec.id === id);
}

export function segmentIndex(state: PlanarGraph, id: string): number {
  return state.segments.findIndex((s) => s.spec.id === id);
}

export function planarGraphSpecs(state: PlanarGraph): SegmentSpec[] {
  return state.segments.map((s) => s.spec);
}

export function graphEdgesForRef(
  state: PlanarGraph,
  ref: LogicalEdgeRef,
): number[] {
  const entry = segmentById(state, ref.segmentId);
  if (entry) {
    const indices = entry.fragments[ref.logicalEdgeIndex];
    if (indices.length > 0) {
      return indices.filter((i) =>
        isVisibleGraphEdge(state.graph.edges[i], state),
      );
    }
  }

  const indices: number[] = [];
  state.graph.edges.forEach((e, i) => {
    if (
      e.ownerSegmentId === ref.segmentId &&
      e.logicalEdgeIndex === ref.logicalEdgeIndex &&
      isVisibleGraphEdge(e, state)
    ) {
      indices.push(i);
    }
  });
  return indices;
}
